import React from "react";

// photo just example
const data = {
  photo: "http://localhost:3000/checkout/Cover2.png",
  price: "41.66",
  pages: "47",
  paperSize: "A4",
  paperColor: "#F7F7F7",
  subtotal: "GBP 41.66",
  vat: "GBP 8.33",
  shipping: "FREE",
  total: "49,99",
};

export default function RightSide() {
  return (
    <div class="pt-[32px] flex flex-col pr-[30px] w-[80%]">
      <div class="flex">
        <div>
          <img
            class="w-[206px] h-[291px]"
            src={require("../Theme/Img/Cover2.png")}
            alt="story book"
          />
        </div>
        <div>
          <div class="pl-[32px] pt-[15px]">
            <h2 class="text-main-color text-textSec text-[20px] font-[600] pb-[16px]">
              GBP {data.price}
            </h2>
            <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400] pb-[6px]">
              Storybook
            </p>
            <p class="text-main-color text-textSec text-[16px] font-[600] pb-[82px]">
              The Haunted House
            </p>
          </div>
          <div class="flex justify-between pl-[32px]">
            <div class="flex flex-col">
              <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400] pb-[16px]">
                Pages
              </p>
              <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400] pb-[16px]">
                Paper Size
              </p>
              <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400]">
                Paper Color
              </p>
            </div>
            <div class="flex flex-col absolute right-[15%]">
              <p class="text-main-color text-textSec text-[16px] font-[600]  pb-[16px]">
                {data.pages}
              </p>
              <p class="text-main-color text-textSec text-[16px] font-[600]  pb-[16px]">
                {data.paperSize}
              </p>
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  background: `${data.paperColor}`,
                  border: "1px solid #EBB268",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-[100%] h-[1px] bg-[#ECECEC] mt-[48px] mb-[17px]"></div>
      <div class="flex justify-between  pr-[10%]">
        <div class="flex flex-col">
          <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400] pb-[16px]">
            Subtotal (1x Storybook)
          </p>
          <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400] pb-[16px]">
            VAT 20%
          </p>
          <p class="text-[#C5C3C3] text-textSec text-[14px] font-[400]">
            Shipping Fee
          </p>
        </div>
        <div class="flex flex-col text-right">
          <p class="text-main-color text-textSec text-[16px] font-[600]  pb-[16px]">
            {data.subtotal}
          </p>
          <p class="text-main-color text-textSec text-[16px] font-[600]  pb-[16px]">
            {data.vat}
          </p>
          <p class="text-main-color text-textSec text-[16px] font-[600]  pb-[16px]">
            {data.shipping}
          </p>
        </div>
      </div>
      <div class="w-[100%] h-[1px] bg-[#ECECEC] mt-[17px] mb-[17px]"></div>
      <div class="flex justify-between  pr-[10%]">
        <p class="text-[#C5C3C3] text-textSec text-[16px] font-[600]">
          Shipping Fee
        </p>
        <p class="text-main-color text-textSec text-[20px] font-[700] pb-[16px]">
          GBR {data.total}
        </p>
      </div>
    </div>
  );
}
